export const DGR_INSTAGRAM_URL = 'https://instagram.com/gentlemansride';

export const DGR_RIDE_DAY = '2026-05-17';
export const DGR_DEFAULT_START_HOUR = 9;
export const DGR_RIDE_DURATION_MS = 3 * 60 * 60 * 1000;
// First ride: New Zealand 8:00am NZST = May 16 2026 20:00 UTC
export const FIRST_RIDE_UTC_MS = Date.UTC(2026, 4, 16, 20, 0, 0);
// event_date can be stored with timezone offsets (NZ midnight stored as UTC etc.),
// so a strict "YYYY-MM-DD" string match drops legitimate ride day events. Instead
// accept any event_date within ±24h of noon UTC on ride day, which covers every
// reasonable timezone interpretation of "2026-05-17".
export const RIDE_DAY_NOON_UTC_MS = Date.UTC(2026, 4, 17, 12, 0, 0);
export const RIDE_DAY_WINDOW_MS = 24 * 60 * 60 * 1000;

// Inline SVG fractal noise grain used on the "Riding now" gold KPI card.
// Adds tactile depth without shipping a separate raster asset.
export const GOLD_CARD_NOISE_URL = `url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 240'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;
